import { useLocation } from 'react-router-dom';

const ErrorScreen = ({ error }: ErrorScreenProps) => {
  const location = useLocation<LocationType>();

  return (
    <div className="text-center mt-5">
      <h2 className="text-danger py-5">{location.state.titulo}</h2>
      <p className="text-danger">{location.state.descripcion}</p>
    </div>
  );
};

export default ErrorScreen;

interface ErrorScreenProps {
  error: string;
}

type LocationType = {
  titulo: string;
  descripcion: string;
};
